import { useNavigate } from 'react-router-dom';
import type { Video } from '@/mocks/videos';

interface VideoCardProps {
  video: Video;
}

export default function VideoCard({ video }: VideoCardProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      navigate(`/article/${video.slug}`);
    }, 150);
  };

  const formatViews = (views: number) => {
    if (views >= 10000) {
      return `${(views / 10000).toFixed(1)}万`;
    }
    return views.toString();
  };

  return (
    <article
      className="group cursor-pointer rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
      onClick={handleClick}
      data-product-shop=""
    >
      <div className="relative aspect-video overflow-hidden">
        <img
          src={video.thumbnail}
          alt={`${video.title} - 嫩草视频高清在线观看`}
          title={`${video.title} - 嫩草视频热播影视剧`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
        {video.isNew && (
          <span className="absolute top-2 left-2 bg-accent-500 text-background-50 text-xs px-2 py-0.5 rounded whitespace-nowrap font-medium">新</span>
        )}
        {video.isHot && !video.isNew && (
          <span className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded whitespace-nowrap font-medium">热播</span>
        )}
        <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-0.5 rounded whitespace-nowrap">
          {video.episode}
        </div>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-play-fill text-2xl"></i>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 mb-1.5 group-hover:text-primary-500 transition-colors">
          {video.title}
        </h3>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <div className="flex items-center gap-1">
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-star-fill text-accent-500 text-xs"></i>
            </div>
            <span>{video.rating}</span>
          </div>
          <span>{formatViews(video.views)}次播放</span>
        </div>
        <div className="flex items-center gap-1.5 mt-2 flex-wrap">
          {video.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="text-[11px] text-foreground-500 bg-background-100 px-1.5 py-0.5 rounded whitespace-nowrap">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}